import {isNotNil} from 'ramda-adjunct';

import {normalizeSearchText} from './normalizeSearchText';

/**
 * Column search predicate shared by the filter and columns panels: a column
 * matches when the already-normalised `normalizedTerm` occurs in its header
 * name OR in its group's display label. Both sides go through
 * `normalizeSearchText`, so the match is case- and diacritics-insensitive —
 * "uzywane" finds every column of a "Ford Używane" group.
 *
 * Callers normalise the term once per keystroke and own the empty-term policy
 * (list filters return everything, scroll-to marks return nothing), so
 * `normalizedTerm` is expected to be non-empty here.
 */
export const matchesColumnSearch = (
  headerName: string,
  groupLabel: string | undefined,
  normalizedTerm: string
): boolean =>
  normalizeSearchText(headerName).includes(normalizedTerm) ||
  (isNotNil(groupLabel) && normalizeSearchText(groupLabel).includes(normalizedTerm));
